'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TERMS_OF_SERVICE_GET_STATUS_COMPLETE = exports.TERMS_OF_SERVICE_GET_STATUS_START = exports.TERMS_OF_SERVICE_FAILURE = exports.TERMS_OF_SERVICE_COMPLETE = exports.TERMS_OF_SERVICE_ALREADY_ACCEPTED = exports.TERMS_OF_SERVICE_ADDED = exports.TERMS_OF_SERVICE_START = undefined;
exports.acceptTermsOfService = acceptTermsOfService;
exports.getTermsOfServiceAcceptanceStatus = getTermsOfServiceAcceptanceStatus;

var _httpService = require('../../helpers/httpService');

var HTTP = _interopRequireWildcard(_httpService);

var _config = require('../../config');

var _logging = require('../lib/app/logging');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// -------------------------------------------------------------- CONFIGURATION --------------------------------------------------------------

var configuration = void 0;
var config = function config() {
    return !configuration ? _config.Configuration.getConfig() : configuration;
};
var baseUrl = function baseUrl() {
    return config().service.baseUrl;
};

// -------------------------------------------------------------- LOGGING --------------------------------------------------------------

var logger = void 0;
function loggingHelper(msg, attributes) {
    if (!logger) {
        logger = (0, _logging.appLogger)().create('action-terms-of-service');
    }
    logger.error(msg, attributes);
}

// Action Strings
var TERMS_OF_SERVICE_START = exports.TERMS_OF_SERVICE_START = 'TERMS_OF_SERVICE_START';
var TERMS_OF_SERVICE_ADDED = exports.TERMS_OF_SERVICE_ADDED = 'TERMS_OF_SERVICE_ADDED';
var TERMS_OF_SERVICE_ALREADY_ACCEPTED = exports.TERMS_OF_SERVICE_ALREADY_ACCEPTED = 'TERMS_OF_SERVICE_ALREADY_ACCEPTED';
var TERMS_OF_SERVICE_COMPLETE = exports.TERMS_OF_SERVICE_COMPLETE = 'TERMS_OF_SERVICE_COMPLETE';
var TERMS_OF_SERVICE_FAILURE = exports.TERMS_OF_SERVICE_FAILURE = 'TERMS_OF_SERVICE_FAILURE';

var TERMS_OF_SERVICE_GET_STATUS_START = exports.TERMS_OF_SERVICE_GET_STATUS_START = 'TERMS_OF_SERVICE_GET_STATUS_START';
var TERMS_OF_SERVICE_GET_STATUS_COMPLETE = exports.TERMS_OF_SERVICE_GET_STATUS_COMPLETE = 'TERMS_OF_SERVICE_GET_STATUS_COMPLETE';

function getheader(state) {
    var header = { 'Content-Type': 'application/json' };

    if (state && state.auth && state.auth.authInfo && state.auth.authInfo.access_token) {
        header.Authorization = 'Bearer ' + state.auth.authInfo.access_token;
    }

    return header;
}

function acceptTermsOfService() {
    return function (dispatch, getState) {
        dispatch({ type: TERMS_OF_SERVICE_START });

        var reqUrl = baseUrl() + '/users/tos';
        var state = getState();
        var header = getheader(state);

        // First check if they have accepted the TOS
        return HTTP.putData(reqUrl, header).then(function (response) {
            dispatch({ type: TERMS_OF_SERVICE_ADDED, contents: response });
            dispatch({ type: TERMS_OF_SERVICE_COMPLETE, contents: response });
        }).catch(function (error) {
            if (error.status === '401') {
                // authentication failed
                loggingHelper('Terms of Service authentication failed', { method: 'acceptTermsOfService', error: error });
            } else if (error.status === '404') {
                // user doesn't exist
                loggingHelper('Terms of Service user doesnt exist', { method: 'acceptTermsOfService', error: error });
            } else {
                loggingHelper('Terms of Service error', { method: 'acceptTermsOfService', error: error });
            }

            dispatch({ type: TERMS_OF_SERVICE_FAILURE, contents: error });
        });
    };
}

function getTermsOfServiceAcceptanceStatus(statusLoaded) {
    return function (dispatch, getState) {
        dispatch({ type: TERMS_OF_SERVICE_GET_STATUS_START });

        var reqUrl = baseUrl() + '/users/tos';
        var state = getState();
        var header = getheader(state);

        return HTTP.getData(reqUrl, header).then(function (response) {
            if (response.requiredVersionAccepted) {
                dispatch({ type: TERMS_OF_SERVICE_ALREADY_ACCEPTED, contents: response });
            }
            if (statusLoaded) {
                dispatch({ type: TERMS_OF_SERVICE_GET_STATUS_COMPLETE });
            }
        }).catch(function (error) {
            if (error.status === '401') {
                // authentication failed
                loggingHelper('Terms of Service authentication failed', { method: 'getTermsOfServiceAcceptanceStatus', callType: 'GET', error: error });
            } else if (error.status === '404') {
                // user doesn't exist
                loggingHelper('Terms of Service user doesnt exist', { method: 'getTermsOfServiceAcceptanceStatus', callType: 'GET', error: error });
            } else {
                loggingHelper('Terms of Service error', { method: 'getTermsOfServiceAcceptanceStatus', callType: 'GET', error: error });
            }

            dispatch({ type: TERMS_OF_SERVICE_FAILURE, contents: error });
        });
    };
}


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/shared/actions/terms-of-service.js
// module id = 767
// module chunks = 0